import queryString from 'query-string';

/**
 * Returns if the user is in training mode determined by the query string in
 * the URL
 */
export const isInTrainingMode = () => {
    const queryParameters = queryString.parse(location.search);

    return 'training' in queryParameters && queryParameters.training === 'true';
};
